import React, { useState } from "react";
import DiaglogBox from "../DiaglogBox";
import { ReactComponent as Arrow } from "../../svgs/tableArrow.svg";
import Button from "../Button";
import DownlaodButton from "../../atoms/DownloadButton";

const ViewRequestsDocuments = ({ open, onCancel, requestDocuments }) => {
  if (!requestDocuments) {
    return null;
  }

  const acknowledgmentLink = requestDocuments.acknowledgment || "";
  const documentOneLink = requestDocuments.doc_one || "";
  const documenttwoLink = requestDocuments.doc_two || "";

  const handleAcknowlegementView = () => {
    if (acknowledgmentLink) {
      window.open(acknowledgmentLink, "_blank");
    }
  };

  const handleDocumentOneView = () => {
    if (documentOneLink) {
      window.open(documentOneLink, "_blank");
    }
  };
  const handleDocumentTwoView = () => {
    if (documenttwoLink) {
      window.open(documenttwoLink, "_blank");
    }
  };

  return (
    <div>
      <DiaglogBox open={open} onCancel={onCancel} width={500}>
        <div className="mx-9 pb-7 ">
          <div className="flex flex-row justify-between font-bold text-sm pt-6 pb-2">
            <p className="flex">
              <span className="mt-1.5">
                <Arrow className="h-2 w-2 mr-2" />
              </span>
              Documents
            </p>
            <p className="flex">
              <span className="mt-1.5">
                <Arrow className="h-2 w-2 mr-2" />
              </span>{" "}
              Action
            </p>
          </div>
          <hr className="border-solid- border-1 border-gray-300" />
          <div className="flex flex-row justify-between font-bold text-sm h-14 items-center">
            <p className="text-sm">Acknowledgement</p>
            <div className="flex justify-end gap-2 text-xs">
              <Button
                color="lightblue"
                varient="secondary"
                className="text-blue-800 w-24 h-7 "
                onClick={handleAcknowlegementView}
              >
                View
              </Button>
              <DownlaodButton fileUrl={acknowledgmentLink} />
            </div>
          </div>
          <hr className="border-solid- border-1 border-gray-300" />

          <hr className="border-solid- border-1 border-gray-300" />
          <div className="flex flex-row justify-between font-bold text-sm h-14 items-center">
            <p className="text-sm ">Document 1</p>
            <div className="flex justify-end gap-2 text-xs">
              <Button
                color="lightblue"
                varient="secondary"
                className="text-blue-800 w-24 h-7 "
                onClick={handleDocumentOneView}
              >
                View
              </Button>
              <DownlaodButton fileUrl={documentOneLink} />
            </div>
          </div>
          <hr className="border-solid- border-1 border-gray-300" />
          <div className="flex flex-row justify-between font-bold text-sm h-14 items-center">
            <p className="text-sm">Document 2</p>
            <div className="flex justify-end gap-2 text-xs">
              <Button
                color="lightblue"
                varient="secondary"
                className="text-blue-800 w-24 h-7 "
                onClick={handleDocumentTwoView}
              >
                View
              </Button>
              <DownlaodButton fileUrl={documenttwoLink} />
            </div>
          </div>
          <hr className="border-solid- border-1 border-gray-300" />
        </div>
      </DiaglogBox>
    </div>
  );
};

export default ViewRequestsDocuments;
